//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'GFR_Cockcroft',
  data() {
    return {
      defaultJson: {
        "Weight": "体重",
        "Age": "年龄",
        "Clearance": "清除率",
        "Serum Creatinine": "血肌酐",
      },
      form: {
        age: '',
        weight: '',
        creat: '',
        gender: '',

      },
      contentDescription: '',
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: '男' },
        { value: "5", name: '女' },
      ],
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log('gggggggg', form.creat);
        // gender.isFemale ?		(1.04 * weight * (140 - age) / creat) :		(1.23 * weight * (140 - age) / creat)
        let result = form.gender == '5' ? (1.04 * form.weight * (140 - form.age) / form.creat) : (1.23 * form.weight * (140 - form.age) / form.creat)

        self.hasScore = true
        return String(result.toFixed(0))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/GFR_Cockcroft.vue